import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useEditClient = (setShowEditForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.EDIT_CLIENT],
    (data) => ApiService.editClient(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_CLIENT_LIST);
        setShowEditForm(false);
        toast.success("Customer edited successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useEditClient;
